import { CALL_COST_PER_MINUTE_USD } from "../../config/pricing";

export const generateStatsFromCalls = (calls = []) => {
  const totalCalls = calls.length;

  const completedCalls = calls.filter(
    (call) => call.status === "completed",
  ).length;

  const totalDurationSeconds = calls.reduce(
    (acc, call) => acc + (call.duration || 0),
    0,
  );

  const totalMinutes = (totalDurationSeconds / 60).toFixed(1);
  const totalMinutesNumber = totalDurationSeconds / 60;

  const averageDurationMinutes = totalCalls
    ? +((totalDurationSeconds / totalCalls) / 60).toFixed(2)
    : 0;

  const completionRate = totalCalls
    ? +((completedCalls / totalCalls) * 100).toFixed(1)
    : 0;

  const totalQueueSeconds = calls.reduce(
    (acc, call) => acc + (call.queue_time || 0),
    0,
  );

  const averageQueueSeconds = totalCalls
    ? +(totalQueueSeconds / totalCalls).toFixed(1)
    : 0;

  const totalCost = totalMinutesNumber * CALL_COST_PER_MINUTE_USD;

  return [
    {
      key: "calls",
      label: "Total Calls",
      value: totalCalls,
      icon: "phone",
      trend: "up",
      delta: 0,
      deltaPercent: 0,
    },
    {
      key: "completion-rate",
      label: "Completion Rate (%)",
      value: completionRate,
      icon: "shield",
      trend: "up",
      delta: 0,
      deltaPercent: 0,
    },
    {
      key: "avg-duration",
      label: "Avg Duration (min)",
      value: averageDurationMinutes,
      icon: "agents",
      trend: "up",
      delta: 0,
      deltaPercent: 0,
    },
    {
      key: "avg-queue",
      label: "Avg Queue (sec)",
      value: averageQueueSeconds,
      icon: "dashboard",
      trend: "up",
      delta: 0,
      deltaPercent: 0,
    },
    {
      key: "minutes",
      label: "Total Minutes",
      value: totalMinutes,
      icon: "phone",
      trend: "up",
      delta: 0,
      deltaPercent: 0,
    },
    {
      key: "cost",
      label: "Total Cost",
      value: totalCost.toFixed(2),
      icon: "dollar",
      trend: "up",
      delta: 0,
      deltaPercent: 0,
      isCurrency: true,
    },
  ];
};
